import { create, retrieve, retrieveCollection, update } from "framework/http/endpoint";
import { createCollectionResponseFactory, createEntityResponseFactory } from "framework/http/rest/jsonResponse";
import { fromApiTransportDate, intoApiTransportDate } from "framework/http/transport";
import { createEntityRequest } from "framework/http/rest/jsonRequest";
import { UrlPathOfApiLocation } from "common/paths";
var MemberLoansApiUri = "".concat(UrlPathOfApiLocation, "/api/1/loans");
function intoTransportMemberLoan(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    result.fromDate = intoApiTransportDate(entity.fromDate);
    result.toDate = intoApiTransportDate(entity.toDate);
    result.createdDate = intoApiTransportDate(entity.createdDate);
    return result;
}
function fromTransportMemberLoan(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    result.fromDate = fromApiTransportDate(entity.fromDate);
    result.toDate = fromApiTransportDate(entity.toDate);
    result.endedDate = fromApiTransportDate(entity.endedDate);
    result.createdDate = fromApiTransportDate(entity.createdDate);
    result.acceptedByClubDate = fromApiTransportDate(entity.acceptedByClubDate);
    result.acceptedByMemberDate = fromApiTransportDate(entity.acceptedByMemberDate);
    return result;
}
function loadListOfMemberLoans(parameters) {
    var uri = "".concat(MemberLoansApiUri, "?").concat(Object.keys(parameters).map(function (k) { return "".concat(k, "=").concat(parameters[k]); }).join("&"));
    return retrieveCollection(uri, null, null, createCollectionResponseFactory(fromTransportMemberLoan));
}
function apiGetMemberLoans(memberIdt, memberClubId, hostingClubId, status) {
    if (memberIdt === void 0) { memberIdt = null; }
    if (memberClubId === void 0) { memberClubId = null; }
    if (hostingClubId === void 0) { hostingClubId = null; }
    if (status === void 0) { status = null; }
    var filter = null;
    if (memberIdt !== null) {
        filter = "memberIdt=".concat(memberIdt);
    }
    if (memberClubId !== null) {
        filter = "memberClubId=".concat(memberClubId);
    }
    if (hostingClubId !== null) {
        filter = "hostingClubId=".concat(hostingClubId);
    }
    if (status !== null) {
        filter = "status=".concat(status);
    }
    var uri = filter !== null ? "".concat(MemberLoansApiUri, "?filter=").concat(filter) : MemberLoansApiUri;
    return retrieve(uri, null, createCollectionResponseFactory(fromTransportMemberLoan));
}
function apiGetMemberLoan(id) {
    var uri = "".concat(MemberLoansApiUri, "/").concat(id);
    return retrieve(uri, null, createEntityResponseFactory(fromTransportMemberLoan));
}
function apiUpdateMemberLoanStatus(id, status) {
    var uri = "".concat(MemberLoansApiUri, "/").concat(id);
    var data = {
        id: id,
        status: status,
    };
    var transport = intoTransportMemberLoan(data);
    var request = createEntityRequest(transport);
    return update(uri, request, createEntityResponseFactory(fromTransportMemberLoan));
}
function apiCreateMemberLoan(memberLoanData) {
    var uri = MemberLoansApiUri;
    var transport = intoTransportMemberLoan(memberLoanData);
    var request = createEntityRequest(transport);
    return create(uri, request, createEntityResponseFactory(fromTransportMemberLoan));
}
export { loadListOfMemberLoans, apiGetMemberLoans, apiGetMemberLoan, apiUpdateMemberLoanStatus, apiCreateMemberLoan, };
